import { render, staticRenderFns } from "./AddSubAccountForm.vue?vue&type=template&id=3335a9a4&scoped=true&"
import script from "./AddSubAccountForm.vue?vue&type=script&lang=js&"
export * from "./AddSubAccountForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3335a9a4",
  null
  
)

export default component.exports